import { render, staticRenderFns } from "./slack.vue?vue&type=template&id=058e2080&scoped=true&"
import script from "./slack.vue?vue&type=script&lang=js&"
export * from "./slack.vue?vue&type=script&lang=js&"
import style0 from "./slack.vue?vue&type=style&index=0&id=058e2080&lang=scss&scoped=true&"
import style1 from "./slack.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e2080",
  null
  
)

export default component.exports